export enum ButtonTypesEnum {
    PRIMARY = 'primary',
    OUTLINE = 'outline',
    TEXT = 'text'
  }

  export enum IconDirectionEnum {
    LEFT = 'left',
    RIGHT = 'right'
  }

export enum ButtonSizeEnum {
  MEDIUM = 'medium',
  LARGE = 'large',
}
